module.exports = __webpack_public_path__ + "img/sup_kyc_6.dcad53c2.jpg";